import types from '@/store/types/DocumentosPosteriores'
import Vue from 'vue';

const state = {
  datosDocsPosterioresPe: {},
  objDocsPosterioresNoEnviadosNet: [],
  objDocsPosterioresEnviadosNet: [],
  objMostrarDetalle: false
}
const getters = {
  [types.getters.GetDatosDocsPosterioresPe]: (state) => {
    let objPe = state.datosDocsPosterioresPe;
    return objPe;
  },
  [types.getters.GetDocsPosterioresNoEnviadosNet]: (state) => {
    return state.objDocsPosterioresNoEnviadosNet;
  },
  [types.getters.GetDocsPosterioresEnviadosNet]: (state) => {
    return state.objDocsPosterioresEnviadosNet;
  },

  [types.getters.GetMostrarDetalle]:(state) => {
    return state.objMostrarDetalle;
  }
}
const mutations = {
  [types.mutations.SetDatosDocsPosterioresPe]: (state, obj) => {
    state.datosDocsPosterioresPe = obj;
  },
  [types.mutations.SetDocsPosterioresNoEnviadosNet]: (state, objDocsPosterioresNoEnviadosNet) => {
    state.objDocsPosterioresNoEnviadosNet = objDocsPosterioresNoEnviadosNet;
  },
  [types.mutations.SetDocsPosterioresEnviadosNet]: (state, objDocsPosterioresEnviadosNet) => {
    state.objDocsPosterioresEnviadosNet = objDocsPosterioresEnviadosNet;
  },

  [types.mutations.SetMostrarDetalle]:(state, pMostrarDetalle) => {
    state.objMostrarDetalle = pMostrarDetalle;
  }
}
const actions = {

  [types.actions.RegistrarDocPosterior]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post(`pajel/informacion_mensual/add`, pObj)
        .then(r => {
          let obj = r.data.resultado;

          // Se considera 1 al elemento que identificará el periodo no definido
          if (r.data.status === 200)
            obj.mesId = obj.mesId != null ? obj.mesId : 1;

          commit(types.mutations.SetDatosDocsPosterioresPe, obj);
          resolve(r);
        });
    });
  },

  [types.actions.RegistrarDocPosteriorV2]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post(`pajel/informacion_mensual/add`, pObj)
        .then(r => {
          let obj = r.data.resultado;
          commit(types.mutations.SetDatosDocsPosterioresPe, obj);
          resolve(r);
        });
    });
  },

  [types.actions.ModificarDocPosterior]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/informacion_mensual/update/${pObj.informacionMensualId}`, pObj)
        .then(r => {
          let obj = r.data.resultado;

          // Se considera 1 al elemento que identificará el periodo no definido
          if (r.data.status === 200) {
            obj.mesId = obj.mesId != null ? obj.mesId : 1;
          }

          commit(types.mutations.SetDatosDocsPosterioresPe, obj);
          resolve(r);
        });
    });
  },

  [types.actions.ModificarDocPosteriorV2]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/informacion_mensual/update/${pObj.informacionMensualId}`, pObj)
        .then(r => {
          let obj = r.data.resultado;
          commit(types.mutations.SetDatosDocsPosterioresPe, obj);
          resolve(r);
        });
    });
  },

  [types.actions.EliminarSolicitudDocPosterior]:({commit}, pSolicitudId) => {
    return new Promise ((resolve,reject) => {
      Vue.prototype.$http.delete(`pajel/informacion_mensual/delete_docs_posteriores/${pSolicitudId}`)
        .then(r => {
          resolve(r);
        });
    });
  },

  [types.actions.ObtenerDocumentoPosterior]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/informacion_mensual/find/${pObj.solicitudId}/${pObj.promocionEmpresarialNetId}/${pObj.mesId}/${pObj.estadoInformacionMensualId}`)
        .then(r => {

          if (Object.keys(r.data).length > 0) {
            commit(types.mutations.SetDatosDocsPosterioresPe, r.data);
          }
          else {
            pObj.mesId = null;
            commit(types.mutations.SetDatosDocsPosterioresPe, pObj);
          }
          resolve(r);
        });
    });
  },

  [types.actions.ObtenerDocumentoPosteriorV2]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/informacion_mensual/find_v2/${pObj.solicitudId}/${pObj.promocionEmpresarialNetId}/${pObj.mesId}/${pObj.estadoInformacionMensualId}`)
        .then(r => {
          if (Object.keys(r.data).length > 0) {
            commit(types.mutations.SetDatosDocsPosterioresPe, r.data);
          }
          else {
            pObj.mesId = null;
            commit(types.mutations.SetDatosDocsPosterioresPe, pObj);
          }
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerDocumentoBorrador]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/informacion_mensual/find/by/promocionnetid/estado/${pObj.promocionEmpresarialNetId}/${pObj.estadoTramite}`)
      .then(r => {
        if (Object.keys(r.data).length > 0) {
          commit(types.mutations.SetDatosDocsPosterioresPe, r.data);
        }
        else {
          pObj.mesId = null;
          commit(types.mutations.SetDatosDocsPosterioresPe, pObj);
        }
        resolve(r);
      });
    });
  },

  /* Relacionados a .NET */
  [types.actions.ObtenerDocsPosterioresNoEnviadosNet]: ({ commit }, pPersonaId) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/informacion_mensual/net/no_enviadas/list/${pPersonaId}`)
        .then(r => {
          commit(types.mutations.SetDocsPosterioresNoEnviadosNet, r.data)
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerDocsPosterioresEnviadosNet]: ({ commit }, pPersonaId) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/informacion_mensual/net/enviadas/list/${pPersonaId}`)
        .then(r => {
          commit(types.mutations.SetDocsPosterioresEnviadosNet, r.data)
          resolve(r);
        });
    });
  },
  [types.actions.EnviarSolicitudDocPosterior]:({commit}, pObj) => {
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.post(`pajel/informacion_mensual/net/enviar_solicitud`, pObj)
        .then(r => {
          resolve(r);
        });
    });
  },
}
export default {
  state,
  actions,
  getters,
  mutations
}
